import ContentViewContainer from "./container";
import ContentView from "./component";
export { ContentView, ContentViewContainer };
export default ContentViewContainer;



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/ContentView/index.ts